import React from 'react';
import { Button } from 'reactstrap';

import '../../../style/layout/Buttons.css';

const getClassName = (className?: string): string =>
  className === undefined ? 'primary-button' : `primary-button ${className}`;

const getDisabled = (disabled?: boolean): boolean =>
  disabled === undefined ? false : disabled;

export default ({
  children,
  className,
  disabled,
  onClick,
  size,
}: {
  children: string | JSX.Element;
  className?: string;
  disabled?: boolean;
  onClick: () => void;
  size?: string;
}): JSX.Element => (
  <Button
    disabled={getDisabled(disabled)}
    className={getClassName(className)}
    onClick={onClick}
    size={size}
  >
    {children}
  </Button>
);
